var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.IconBase,{staticClass:"icon",attrs:{"width":16,"height":16}},[_c(_setup.AirplaneIcon)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }